// PWA install affordance for Deskte CRM.
//
// Behavior (Lissette 2026-06-22):
//   * Inside the CRM app we rely on the BROWSER'S NATIVE address-bar install
//     icon — the same discreet affordance Chrome and Edge already show for any
//     installable site. It never nags and disappears once the app is installed.
//     We no longer render a custom floating "Instalar Deskte" button: it
//     reappeared every browser session (even when the app was already installed)
//     and felt naggy.
//   * On PUBLIC RECIPIENT pages — a client opening a /sign, /upload, /invoice,
//     /quote, /cliente, /form, /book, /intake, /application or /join link — we
//     must NEVER offer to install the CRM. That person is the agent's client,
//     not a Deskte user. We strip the manifest so the page isn't installable at
//     all (no custom UI and no native browser icon). main.jsx also skips the
//     service-worker registration on these pages (see isPublicRecipientPage).
//
// Self-contained (no React, no imports) so it never touches the big
// deskte-full.jsx tree.

// Recipient-facing public route prefixes. Kept in sync with the route getters
// in AuthGate.jsx (/sign, /upload, /share, /invoice, /quote, /cliente, /revision,
// /form, /book, /intake, /application, /join, /encuesta).
const PUBLIC_PREFIXES = [
  '/sign/',
  '/upload/',
  '/share/',
  '/invoice/',
  '/quote/',
  '/cliente/',
  '/revision/',
  '/form/',
  '/book/',
  '/intake/',
  '/application/',
  '/join/',
  '/encuesta/',
];

// True when the current URL is a public link opened by the agent's CLIENT.
export function isPublicRecipientPage() {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname || '';
  return PUBLIC_PREFIXES.some((p) => path.startsWith(p));
}

export function installPwaInstallButton() {
  if (typeof window === 'undefined') return;

  // Public recipient page → make it non-installable so the client is never
  // prompted to install the CRM. Removing the manifest stops BOTH our own UI
  // and the browser's native install icon.
  if (isPublicRecipientPage()) {
    try {
      document
        .querySelectorAll('link[rel="manifest"]')
        .forEach((l) => l.remove());
    } catch (_) {
      /* ignore */
    }
    return;
  }

  // CRM app → no custom button. Rely on the browser's native address-bar
  // install icon (like Chrome). We only suppress Chrome's legacy mobile
  // mini-infobar so nothing auto-pops; the discreet omnibox icon stays and is
  // the single, non-naggy way to install.
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
  });
}
